<template>
  <div class="saved-calc-list">
    <div class="search-title">
      <span class="fa fa-search" @click="searchSavedCalcs($event)"></span>
      <input-control
        v-model="searchTextSavedCalcsInput"
        type="text"
        :no-title="true"
        name="search_title"
        :placeholder="$t('column.nm.title')"
        class="search-title-text"
        @keypress="onEnter($event, searchSavedCalcs)"
      />
    </div>
    <div class="sorting-area">
      <span :class="{'sort-item': true, 'selected': savedCalcOrder === 'nm'}" @click="clickSavedCalcOrder('nm', $event)">{{ $t('calculator.sort.title') }} <span><i :class="'fa fa-play ' + savedCalcDirection" /></span></span>
      <span :class="{'sort-item': true, 'selected': savedCalcOrder === 'id'}" @click="clickSavedCalcOrder('id', $event)">{{ $t('calculator.sort.time') }} <span><i :class="'fa fa-play ' + savedCalcDirection" /></span></span>
      <span :class="{'sort-item': true, 'selected': savedCalcOrder === 'likeCo'}" @click="clickSavedCalcOrder('likeCo', $event)">{{ $t('calculator.sort.like_co') }} <span><i :class="'fa fa-play ' + savedCalcDirection" /></span></span>
    </div>
    <div class="saved-calcs-list-container" @scroll="onScrollSavedCalcs">
      <div v-if="savedCalcsTotal === 0" class="no-data">
        {{ $t('common.text.no_data') }}
      </div>
      <div v-else class="saved-calcs-list-wrapper">
        <div v-for="(savedCalc, savedCalcIndex) in savedCalcs" :key="'saved-calc-' + savedCalcIndex" class="saved-calc-item calc-item" @click="selectSavedCalc(savedCalc, $event)">
          <div class="name-and-title">
            <div class="name">
              {{ savedCalc.userNm }}
            </div>
            <div class="title">
              {{ savedCalc.nm }}
            </div>
          </div>
          <div class="registration-operation-date">
            {{ savedCalc.rgsOperDt | formatDatetime }}
          </div>
        </div>
        <div class="clear" />
        <div v-if="savedCalcsTotal !== undefined && savedCalcsTotal > savedCalcsLoaded" class="saved-calcs-loading calcs-loading">
          <div class="clear" />
          <img src="/img/ajax-loader-white-bg.gif" alt="Loading">
          <strong>{{ $t('common.text.loading') }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: {
      type: Object,
      default: undefined
    },
    initConditions: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      savedCalcFirstId: undefined,
      savedCalcs: undefined,
      savedCalcsTotal: undefined,
      savedCalcsLoaded: undefined,
      searchTextSavedCalcsInput: '',
      savedCalcOrder: 'id',
      savedCalcDirection: 'desc'
    }
  },
  watch: {
    searchTextSavedCalcsInput: {
      handler(newVal, oldVal) {
        this.emitConditions()
      },
      deep: true
    },
    savedCalcOrder: {
      handler(newVal, oldVal) {
        this.emitConditions()
      },
      deep: true
    },
    savedCalcDirection: {
      handler(newVal, oldVal) {
        this.emitConditions()
      },
      deep: true
    }
  },
  mounted() {
    if (this.initConditions) {
      for (const key in this.initConditions) {
        this[key] = this.initConditions[key]
      }
      if (this.initData) {
        this.initializeWithData()
        return
      }
      this.searchSavedCalcs()
    } else {
      if (this.initData) {
        this.initializeWithData()
        return
      }
      this.loadSavedCalcs(true)
    }
  },
  methods: {
    emitConditions() {
      this.$emit('condition-changed', {
        searchTextSavedCalcsInput: this.searchTextSavedCalcsInput,
        savedCalcOrder: this.savedCalcOrder,
        savedCalcDirection: this.savedCalcDirection
      })
    },
    selectSavedCalc(calc, e) {
      this.$emit('select-calc', {
        calc: calc,
        e: e
      })
    },
    searchSavedCalcs(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
        this.vibrate(e)
      }
      this.searchTextSavedCalcs = this.searchTextSavedCalcsInput
      this.loadSavedCalcs(true)
    },
    async loadSavedCalcs(refresh) {
      if (refresh) {
        this.savedCalcs = undefined
        this.savedCalcFirstId = undefined
        this.savedCalcsLoaded = 0
        window.savedCalcsPage = -1
        this.savedCalcsTotal = undefined
      }
      if (this.savedCalcsTotal === this.savedCalcsLoaded) {
        return
      }
      window.savedCalcsPage++
      let url = '/calc/calcs?shareFlag=N&pageNo=' + window.savedCalcsPage
      if (this.savedCalcFirstId) {
        url += '&firstId=' + this.savedCalcFirstId
      }
      if (this.searchTextSavedCalcs) {
        url += '&searchText=' + encodeURIComponent(this.searchTextSavedCalcs)
      }
      url +=
        '&order=' +
        encodeURIComponent(this.savedCalcOrder) +
        '&direction=' +
        this.savedCalcDirection
      const res = await this.$axios.$get(url)
      if (!this.savedCalcs) {
        this.savedCalcs = res.data.list
      } else {
        this.savedCalcs = this.savedCalcs.concat(res.data.list)
      }

      this.savedCalcsTotal = res.data.totalSize
      if (!this.savedCalcFirstId) {
        this.savedCalcFirstId = res.data.firstId
      }
      if (this.savedCalcs) {
        this.savedCalcsLoaded = this.savedCalcs.length
      }
      this.$nextTick(() => {
        this.onScrollSavedCalcs()
      })
    },
    emitScrollAndData() {
      this.$emit('scroll-and-data', {
        list: this.savedCalcs,
        total: this.savedCalcsTotal,
        firstId: this.savedCalcFirstId,
        loaded: this.savedCalcsLoaded,
        scrolledY: this.scrolledY
      })
    },
    initializeWithData() {
      this.savedCalcs = this.initData.list
      this.savedCalcsTotal = this.initData.total
      this.savedCalcFirstId = this.initData.firstId
      this.savedCalcsLoaded = this.initData.loaded
      this.$nextTick(() => {
        $(this.$el)
          .find('.saved-calcs-list-container')
          .scrollTop(this.initData.scrolledY)
      })
    },
    clickSavedCalcOrder(order, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      if (order === this.savedCalcOrder) {
        if (this.savedCalcDirection === 'asc') {
          this.savedCalcDirection = 'desc'
        } else {
          this.savedCalcDirection = 'asc'
        }
      } else {
        this.savedCalcDirection = 'desc'
        this.savedCalcOrder = order
      }
      this.loadSavedCalcs(true)
    },
    onScrollSavedCalcs(e) {
      const comp =
        $('.saved-calcs-list-wrapper').height() -
        $('.saved-calcs-list-container').height()
      const top = $('.saved-calcs-list-container').scrollTop()
      if (comp - top < 50) {
        this.loadSavedCalcs(false)
      }
      this.scrolledY = top
      this.emitScrollAndData()
    }
  }
}
</script>

<style scoped>
.saved-calcs-list-container {
  padding: 0 1.1666666rem;
  height: calc(100vh - 20.4rem);
  overflow-y: auto;
  overflow-x: hidden;
}
.saved-calc-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3.816rem;
  border-top: 1px solid #eeeeee;
}
.search-title .fa {
  color: #360ea6;
  font-size: 1.5rem;
  margin-left: 1.708333333333333rem;
  position: absolute;
  z-index: 4;
}
.search-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3.708333333333333rem;
  background: #f1f1f1;
}
.search-title {
  padding: 1rem 0;
}
.search-title >>> input[type='text']::placeholder,
.search-title >>> input[type='text'] {
  font-size: 0.95rem !important;
}
.search-title >>> input[type='text'] {
  padding: 0 0.7rem;
  padding-left: 2.6rem;
  height: 2.291666666666667rem;
}
.search-title-text {
  height: 2.291666666666667rem;
  border: none;
  margin-left: 1rem;
  width: calc(100vw - 2rem);
}
.search-title-text >>> input {
  border: none !important;
  box-shadow: none !important;
}
.sorting-area .fa-play {
  transform: rotate(270deg);
}
.sorting-area .selected .fa-play.desc {
  transform: rotate(90deg);
}
.sorting-area {
  color: #e5e5e5;
  font-size: 0.825rem;
  margin-bottom: 1rem;
  padding: 0 1.1666666rem;
}
.sorting-area .selected {
  color: #360ea6;
}
.sort-item {
  margin-right: 1.5rem;
}
.sort-item .fa {
  margin-left: 0.5rem;
}
.calc-item .name {
  font-weight: bold;
}
.calc-item .title {
  font-weight: lighter;
  overflow: hidden;
  line-height: 1.2rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.calc-item .name,
.calc-item .title {
  font-size: 1rem;
}
.calc-item .registration-operation-date {
  font-size: 1rem;
  width: 9.3rem;
}
.calc-item .name-and-title {
  width: calc(100% - 9.3rem);
}
.calcs-loading {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
>>> .input-control {
  min-height: auto;
  margin-bottom: 0;
}
.no-data {
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 10rem;
}
</style>
